import StaticClock from "../../components/UKG/Mathematics/ChooseTime";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/mathematics/time/choose-correct-time", title: "Choose Correct Time", component: StaticClock},
];


export default topics;